<template>
  <div>
    <h4
      data-v-8e45b648
      class="mb-3 text-primary text-center text-sm-left mb-4 font-weight-bold"
    >{{ $t('heading') }}</h4>
    <div class="row mb-4">
      <div class="col-sm-6">
        <label for="newsletter-freq">{{ $t('howOften') }}</label>
        <b-form-select
          @change="updateFrequency"
          id="newsletter-freq"
          v-model="newsletterFrequency.model"
          :options="newsletterFrequency.options"
        ></b-form-select>
      </div>
    </div>
    <div v-if="followingSpeakers.length > 0">
      <div class="row">
        <div class="col-md-6">
          <b-form-input
            id="input-3"
            v-model="filterQuery"
            :placeholder="$_t('KW:filterMagidShiur')"
          ></b-form-input>
        </div>
      </div>
      <paginate
        class="p-0"
        name="filteredFollowingSpeakers"
        :list="filteredFollowingSpeakers"
        :per="8"
      >
        <magidei-list type="torah" :magidei-shiur="paginated('filteredFollowingSpeakers')"></magidei-list>
      </paginate>
      <paginate-links
        v-if="paginated('filteredFollowingSpeakers').length < filteredFollowingSpeakers.length"
        :classes="{
    'ul': 'pagination',
    'li': 'page-item',
    'a': 'page-link',
      }"
        for="filteredFollowingSpeakers"
      ></paginate-links>
    </div>
    <div v-else>
      <div class="alert alert-info">{{ $t('caption') }}</div>
    </div>
  </div>
</template>

<script>
import MagideiListComponent from "../magideiShiur/magideiList.vue";
import Vue from "vue";
import VuePaginate from "vue-paginate";
Vue.use(VuePaginate);

export default {
  components: {
    MagideiList: MagideiListComponent,
  },
  i18nOptions: {
    namespaces: "components",
    keyPrefix: "followingSpeaker",
  },
  data() {
    return {
      filterQuery: "",
      filteredFollowingSpeakers: [],
      paginate: ["filteredFollowingSpeakers"],
    };
  },
  watch: {
    followingSpeakers: function (newVal) {
      this.filteredFollowingSpeakers = newVal;
    },
    filterQuery: function (newVal) {
      if (newVal.length > 0) {
        this.filteredFollowingSpeakers = this.followingSpeakers.filter(
          (speaker) => speaker.name.toLowerCase().includes(newVal.toLowerCase())
        );
      } else {
        this.filteredFollowingSpeakers = this.followingSpeakers;
      }
    },
  },
  computed: {
    followingSpeakers: function () {
      let speakers = this.$store.state.profile.followedSpeakers;
      this.filteredFollowingSpeakers = speakers;
      return speakers;
    },
    newsletterFrequency: function () {
      return {
        model: this.$store.state.profile.shiurimNewsletter
          ? this.$store.state.profile.shiurimNewsletter.frequency
          : this.$_t("KW:daily"),
        options: [this.$_t("KW:daily"), this.$_t("KW:never")],
      };
    },
  },
  methods: {
    updateFrequency() {
      axios.post("api/user/update-shiurim-newsletter-frequency", {
        frequency: this.newsletterFrequency.model,
      });
    },
  },
};
</script>

<style>
</style>